"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecializationUpdateDto = void 0;
const specialization_1 = require("../specialization");
const misc_1 = require("../../../misc");
class SpecializationUpdateDto extends (0, misc_1.generateUpdateDto)(specialization_1.Specialization, ['name', 'parentSpecIds']) {
}
exports.SpecializationUpdateDto = SpecializationUpdateDto;
